export const initialValues = {
    customerEmail: '',
    salutation: '',
    firstName: '',
    lastNamePrefix: '',
    lastName: '',
    street: '',
    newStreet: '',
    houseNumber: '',
    newHouseNumber: '',
    houseNumberAddition: '',
    newHouseNumberAddition: '',
    zipcode: '',
    newZipcode: '',
    city: '',
    newCity: '',
    phoneNumber: '',
    birthdate: '',
    relocationDate: '',
    store: '',
    storeEmail: '',
    storeTwo: '',
    storeTwoEmail: '',
    sendToDeliveryService: false,
    termsAgreed: false,
};
